<div
  *ngIf="(status$ | async) !== CarTrawlerWidgetStatus.ERROR"
  [id]="containerId"
  [class]="'cartrawler-widget rounded-large border ps-large white-bg ' + extraClasses"
>
  <fcom-loader
    *ngIf="(status$ | async) === CarTrawlerWidgetStatus.LOADING"
    [loaderType]="LoaderTheme.INLINE"
  ></fcom-loader>
</div>
